import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const ChipContainer = styled('div', {
  display: 'inline-flex',
  overflow: 'auto',
  scrollBehavior: 'smooth',
  paddingRight: '40px',
  '@media (max-width: 744px)': {
    gap: '8px',
  },
  '@media (min-width: 745px)': {
    gap: '12px',
  },
  scrollbarColor: 'transparent transparent' /* Hide scrollbar for Firefox */,
  /**
   * This CSS class override div styled + add pseudo class to hide the horizontal scrollbar,
   * but keet its functionality.
   * Only for this div container.
   * */
  '&.hide-scrollbar': {
    display: 'inline-flex',
    overflow: 'auto',
    scrollBehavior: 'smooth',
    '@media (max-width: 744px)': {
      gap: '8px',
    },
    '@media (min-width: 745px)': {
      gap: '12px',
    },
  },
  '&.hide-scrollbar::-webkit-scrollbar': {
    display: 'contents' /* Hide scrollbar for Chrome, Safari and Opera */,
  },
});

export const Wrapper = styled(Flex, {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  '@media (max-width: 464px)': {
    marginTop: '8px',
  },
  '@media (max-width: 744px)': {
    marginTop: '8px',
  },
  '@media (min-width: 745px)': {
    paddingTop: '12px',
  },
});

export const ChipMenuIcon = styled('div', {
  display: 'inline-flex',
  '@media (max-width: 744px)': {
    marginRight: '8px',
  },
  '@media (min-width: 745px)': {
    marginRight: '12px',
  },
});

export const CareCategoriesText = styled('h4', {
  color: '#323334 !important',
  paddingBottom: '36px',
});

export const WrapperStyle = {
  height: '52px',
  '@media (max-width: 464px)': {
    height: '43px',
  },
};

export const WrapperHeightStyle = {
  '@media (max-width: 464px)': {
    height: '43px',
  },
  '@media (max-width: 744px)': {
    height: '52px',
    paddingLeft: '16px',
  },
  '@media (min-width: 745px)': {
    height: '84px',
  },
};

export const MenuList = styled('div', {
  margin: '50px 0 0 10px',
  background: '$core.color.neutral.0',
  border: '1px solid $core.color.brand.100',
  borderRadius: '12px',
  padding: '$lg',
  position: 'absolute',
  zIndex: 99,
  minWidth: '260px',
});

export const chipSelectorDrawerMobile = {
  'abyss-modal-close-button': {
    '@media (max-width: 744px)': {
      marginTop: '15px',
      marginRight: '15px',
    },
    '@media (max-width: 464px)': {
      marginTop: '8px',
      marginRight: '10px',
    },
  },
  'abyss-modal-header-container': {
    '@media (max-width: 744px)': {
      padding: '$lg $lg 32px',
    },
    '@media (max-width: 464px)': {
      padding: '$md $md 28px',
    },
  },
  'abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0px 0px',
    height: 'auto !important',
  },
  'abyss-modal-content-title': {
    color: '#323334 !important',
    fontFamily: '$primary !important',
    fontWeight: 'var(--abyss-psx-parcel-fontWeights-bold) !important',
    fontStyle: 'normal',
    fontSize: '20.25px !important',
    lineHeight: '24px !important',
    padding: 0,
  },
  'abyss-modal-base-body': {
    '@media (max-width: 744px)': {
      padding: '4px $lg $lg',
    },
    '@media (max-width: 464px)': {
      padding: '4px $md $md',
    },
  },
};

export const ChangeButton = styled(Button, {
  width: '100%',
  marginTop: '10px',
  borderradius: '24px',
  lineHeight: '20px',
  fontWeight: '600',
  textAlign: 'center',
  '&.abyss-button-content-container': {
    margin: '0',
  },
});

export const hamburgerButton = {
  'abyss-button-root': {
    padding: '0px 0px 0px 0px',
    border: 'none',
    outline: 'none',
    '&:hover, &:focus, &:active': {
      backgroundColor: '#FBFCFE',
      border: 'none',
      outline: 'none',
    },
    '@media (max-width: 464px)': {
      paddingBottom: '7px',
    },
  },
};

export const chipsCategory = {
  '&.abyss-heading-root': {
    color: '$core.color.brand.100',
    fontWeight: '600',
    lineHeight: '24px',
    fontSize: '18px',
  },
};

export const ChipCategoryButton = styled(Button, {
  dynamic: ({ cssProps: { disabled } = {} }) => ({
    '&.abyss-button-root': {
      marginLeft: '5px',
      color: '$core.color.neutral.0',
      cursor: 'pointer',
      height: '40px',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
      '&:hover, &:focus, &.active': {
        backgroundColor: !disabled && '$core.color.brand.100 !important',
        '& div': {
          color: disabled ? 'gray' : '$core.color.neutral.0',
        },
      },
      '@media (max-width: 464px)': {
        height: '32px',
        padding: '6px $md',
      },
    },
  }),
});

export const ChipButtonText = styled('div', {
  dynamic: ({ cssProps: { isActive, disabled } = {} }) => ({
    color: isActive
      ? '$core.color.neutral.0'
      : disabled
      ? 'gray'
      : '$core.color.brand.100',
    '&:hover, &:focus': {
      color: disabled ? 'gray' : '$core.color.neutral.0',
    },
  }),
  whiteSpace: 'nowrap',
  fontWeight: '600',
  fontSize: '$md',
  lineHeight: '$md',
  '@media (max-width: 464px)': {
    fontWeight: 'bold',
    fontSize: '14px',
  },
});
